import ajax from './index'
import apiEnv from './apiEnv'
// 行业列表
export function managerIndustryList(data) {
    return ajax.post(`${apiEnv.api1}/api/Admin/Industry/GetManagerIndustryList`, data)
}
// 修改行业状态
export function updateIndustryStatus(data) {
    return ajax.post(`${apiEnv.api1}/api/Admin/Industry/UpdateIndustryStatus`, data)
}
// 获取父级行业
export function industryParent(data) {
    return ajax.get(`${apiEnv.api1}/api/BpoJob/GetIndustry`, data)
}
// 添加行业
export function insertIndustry(data) {
    return ajax.post(`${apiEnv.api1}/api/Admin/Industry/InsertIndustry`, data)
}
// 编辑保存
export function updateIndustry(data) {
    return ajax.post(`${apiEnv.api1}/api/Admin/Industry/UpdateIndustry`, data)
}


//产品库
// 列表
export function productList(data) {
    return ajax.post(`${apiEnv.api2}/gz/product/list`, data)
}
//恢复和作废
export function updateStatus(data) {
    return ajax.post(`${apiEnv.api2}/gz/product/updateStatus`, data)
}
//新增
export function addproduct(data) {
    return ajax.post(`${apiEnv.api2}/gz/product/add`, data)
}
//下拉框
export function getproSelect(data) {
    return ajax.post(`${apiEnv.api2}/gz/product/select`, data)
}
//获取最大序号
export function getSortNo(data) {
    return ajax.post(`${apiEnv.api2}/gz/product/getSortNo`, data)
}
//更新序号
export function updateSortNo(data) {
    return ajax.post(`${apiEnv.api2}/gz/product/updateSortNo`, data)
}
//修改
export function editPro(data) {
    return ajax.post(`${apiEnv.api2}/gz/product/edit`, data)
}

//品牌库
//列表
export function getbrandList(data) {
    return ajax.post(`${apiEnv.api2}/gz/brand/list`, data)
}
export function addbrand(data) {
    return ajax.post(`${apiEnv.api2}/gz/brand/add`, data)
}
export function editbrand(data) {
    return ajax.post(`${apiEnv.api2}/gz/brand/edit`, data)
}
// 恢复作废
export function updatebrand(data) {
    return ajax.post(`${apiEnv.api2}/gz/brand/updateStatus`, data)
}

//系列库
//列表
export function getserialList(data) {
    return ajax.post(`${apiEnv.api2}/gz/serial/list`, data)
}
//品牌下拉
export function getbrandselect(data) {
    return ajax.post(`${apiEnv.api2}/gz/brand/select`, data)
}
//新增
export function addserial(data) {
    return ajax.post(`${apiEnv.api2}/gz/serial/add`, data)
}
// 修改
export function editserial(data) {
    return ajax.post(`${apiEnv.api2}/gz/serial/edit`, data)
}
//作废，恢复
export function updateserial(data) {
    return ajax.post(`${apiEnv.api2}/gz/serial/updateStatus`, data)
}

//服务类型库
//列表
export function getStageList(data) {
    return ajax.post(`${apiEnv.api2}/gz/serviceStage/list`, data)
}
//作废
export function updateStage(data) {
    return ajax.post(`${apiEnv.api2}/gz/serviceStage/updateStatus`, data)
}
//新增
export function addStage(data) {
    return ajax.post(`${apiEnv.api2}/gz/serviceStage/add`, data)
}

//服务库
//服务类型下拉框
export function selectStage(data) {
    return ajax.post(`${apiEnv.api2}/gz/serviceStage/select`, data)
}
//证书下拉框
export function selectCerTypes(data) {
    return ajax.post(`${apiEnv.api2}/gz/serviceOffer/getCertificateTypes`, data)
}
//列表
export function getOfferList(data) {
    return ajax.post(`${apiEnv.api2}/gz/serviceOffer/list`, data)
}
//省市区下拉框
export function getSpecialAreas(data) {
    if(data){
        return ajax.post(`${apiEnv.api2}/gz/serviceOffer/getSpecialAreas?provinceId=${data}`)
    }else{
        return ajax.post(`${apiEnv.api2}/gz/serviceOffer/getSpecialAreas`)
    }

}
//增加
export function addoffter(data) {
    return ajax.post(`${apiEnv.api2}/gz/serviceOffer/add`, data)
}
//修改
export function updateoffter(data) {
    return ajax.post(`${apiEnv.api2}/gz/serviceOffer/edit`, data)
}
//查看详细
export function getoffterDetail(data) {
    return ajax.post(`${apiEnv.api2}/gz/serviceOffer/get?id=${data}`)
}
// 日志
export function getrzdata(data) {
    return ajax.post(`${apiEnv.api2}/gz/serviceOffer/logs/list?serviceOfferId=${data}`)
}
//添加备注
export function addRemark(data) {
    return ajax.post(`${apiEnv.api2}/gz/serviceOffer/logs/addRemark`, data)
}
//作废恢复
export function updateofferStatus(data) {
    return ajax.post(`${apiEnv.api2}/gz/serviceOffer/updateStatus`, data)
}

//发单信息
export function getinvoice(data) {
    return ajax.post(`${apiEnv.api2}/gz/invoice/get`, data)
}
export function saveinvoice(data) {
    return ajax.post(`${apiEnv.api2}/gz/invoice/save`, data)
}
//获取特殊地区
export function getSpecialAreaList(data) {
    return ajax.post(`${apiEnv.api2}/gz/serviceOffer/getDefaultSpecialArea`, data)
}